import { useMemo } from "react";

export const useResourceHoursChanges = (resourceHours, historyHours, isItemAdded) => {
  const hoursChanges = useMemo(() => {
    if (isItemAdded || (!historyHours && !resourceHours)) return [];

    return resourceHours?.map((hours, index) => {
      if (!Array.isArray(historyHours)) return { hoursAdded: true };

      // Can be empty array, so previously worker didn't have hours
      const prevHours = historyHours?.every(h => Array.isArray(h) && h?.length === 2)
        ? historyHours?.find(([key, value]) => +key === +index)?.[1]
        : historyHours?.find((h) => h.id === hours.id);

      if (!prevHours) return {}
      else if (!Object.keys(prevHours).length) return { hoursAdded: true }
      return {
        hoursChanged: (
          (prevHours.start && new Date(hours.start)?.getTime() !== new Date(prevHours.start)?.getTime()) ||
          (prevHours.end && new Date(hours.end)?.getTime() !== new Date(prevHours.end)?.getTime())
        ),
        travelTimeFromChanged: prevHours.travelTimeFrom && (
          hours?.travelTimeFrom?.hours !== prevHours?.travelTimeFrom?.hours ||
          hours?.travelTimeFrom?.minutes !== prevHours?.travelTimeFrom?.minutes
        ),
        travelTimeToChanged: prevHours.travelTimeTo && (
          hours?.travelTimeTo?.hours !== prevHours?.travelTimeTo?.hours ||
          hours?.travelTimeTo?.minutes !== prevHours?.travelTimeTo?.minutes
        ),
      }
    }).map((changes) => {
      if (
        changes?.hoursChanged &&
        changes?.travelTimeFromChanged &&
        changes?.travelTimeToChanged
      ) return { ...changes, allChanged: true }
      return changes;
    })
  }, [isItemAdded, resourceHours, historyHours]);

  const removedHours = useMemo(() => {
    if (isItemAdded || !historyHours?.length) return [];

    const completelyRemoved = historyHours
      .filter(hours => hours?.id)
      .filter(hours => !resourceHours?.length || resourceHours?.every(h => hours.id !== h.id));
    const updatedRemoved = historyHours
      .filter((keyHours) => !!keyHours?.[1]?.id)
      .filter(([key, hours]) => (
        !resourceHours?.length ||
        resourceHours?.every(h => hours.id !== h.id)
      ))
      .map(([key, hours]) => hours);

    return completelyRemoved.concat(updatedRemoved);
  }, [isItemAdded, resourceHours, historyHours]);

  return { hoursChanges, removedHours }
}